export const NOTIFICATIONS_COUNT_LIMIT = 3
export const NOTIFICATION_PREFIX_ID = 'notification-id'
export const NOTIFICATION_AUTOHIDE_DURATION = 10000
